/**
 * Arama sonucu tür rozeti (TI-013): tür simge + metinle (renk tek başına anlam taşımaz).
 * Ayrı dosya: kabuğa her zaman yüklenen arama listesi (`SearchHitView`) yalnız bunu içe aktarır; `SearchPreview` ve onun çektiği
 * çerçeve metinleri (`../strings`) ana pakete girmez (üretim paketi denetimi, scripts/check-web-bundle.mjs).
 */
import type { ReactNode } from 'react';
import {
  Building,
  CalendarCheck,
  ClipboardList,
  FilePen,
  FileText,
  LifeBuoy,
  Package,
  ShoppingCart,
  TrendingUp,
  Truck,
  User,
  UserPlus,
} from 'lucide-react';
import type { SearchRecordType } from '@castinflow/shared';
import { Badge } from '@castinflow/ui';
import { searchStrings as s } from './search-strings';

const ICON: Record<SearchRecordType, ReactNode> = {
  contact: <User size={12} aria-hidden="true" />,
  company: <Building size={12} aria-hidden="true" />,
  product: <Package size={12} aria-hidden="true" />,
  lead: <UserPlus size={12} aria-hidden="true" />,
  opportunity: <TrendingUp size={12} aria-hidden="true" />,
  proposal: <FileText size={12} aria-hidden="true" />,
  order: <ShoppingCart size={12} aria-hidden="true" />,
  purchase_order: <Truck size={12} aria-hidden="true" />,
  contract: <FilePen size={12} aria-hidden="true" />,
  activity: <CalendarCheck size={12} aria-hidden="true" />,
  ticket: <LifeBuoy size={12} aria-hidden="true" />,
  form_document: <ClipboardList size={12} aria-hidden="true" />,
};

export function SearchTypeBadge({ type }: { type: SearchRecordType }) {
  return (
    <Badge tone="neutral" icon={ICON[type]} className="shrink-0">
      <span data-testid="search-type-badge">{s.typeSingular[type]}</span>
    </Badge>
  );
}
